import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"

import MaxWidthContainer from "../components/max-width-container"
import { Link } from "gatsby"
import { StyledP } from "./markdown-elements"

const Credit = styled.small`
  margin: auto;
`

export default function Footer() {
  return (
    <MaxWidthContainer>
      <footer
        css={css`
          display: flex;
          background: var(--color-primary);
          padding: 10px;
          font-size: 12px;
          @media print {
            display: none;
          }
        `}
      >
        <span></span>
        <Credit>
          <StyledP>
             © Tim Roderick, 2020{" "}
            <Link to="/sitemap.xml">Sitemap</Link>
          </StyledP>
        </Credit>
      </footer>
    </MaxWidthContainer>
  )
}

// TODO: Support media query
